import { render, staticRenderFns } from "./Timetable2.vue?vue&type=template&id=2053c57a&scoped=true&"
import script from "./Timetable2.vue?vue&type=script&lang=js&"
export * from "./Timetable2.vue?vue&type=script&lang=js&"
import style0 from "./Timetable2.vue?vue&type=style&index=0&id=2053c57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053c57a",
  null
  
)

export default component.exports